<template>
<div>
    <div style="background-color: #d1d1d1; padding: 15px;">
        <h2 style="font-weight: 400;">Rule Editor</h2>
        <div :class="$style.ruleEditorSection">
            <div>
                <v-btn small depressed color="primary" @click="add_rule">
                    Add Rule
                </v-btn> 
                <v-tooltip right color="black"> 
                    <template v-slot:activator="{on, attrs}">
                        <v-icon class='ml-3'
                            color="black"
                            small 
                            v-bind="attrs" 
                            v-on="on">fas fa-info-circle</v-icon>
                    </template>
                    <span>
                        <b>ANY</b>&nbsp;<i>rule</i> will trigger question display            
                    </span>
                </v-tooltip>
            </div>
            <v-spacer></v-spacer>
            <v-menu offset-y nudge-left='50'>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        large
                        icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        :disabled="rules_trash.length === 0"
                        >
                        <div :class="$style.rulesTrashSection">
                            <v-badge right>
                                <template v-slot:badge>
                                    <span>{{rules_trash.length}}</span>
                                </template>
                                <svgIcon :src="trashIcon" v-bind="attrs" v-on="on" />
                            </v-badge>
                            <span :class="$style.rulesTrashLabel">Rules Trash</span>
                        </div>
                    </v-btn>
                </template>
                
                <v-list v-if="rules_trash.length > 0">
                    <draggable class="list-group" :list="rules_trash" :group="'rules'">
                        <v-list-item
                            v-for="(rule, rule_index) in rules_trash"
                            :key="'rule_trash_item_'+rule_index">
                                Deleted Rule: {{rule_index + 1}}
                        </v-list-item>
                    </draggable>
                </v-list>                                                        
                    
            </v-menu> 
        </div>
        <div style="margin-top: 10px;">
            <draggable 
                :class="[{[$style.emptyRulesWrapper]: rules.length == 0}, 'list-group']" 
                :list="rules" 
                :group="'rules'" 
                handle=".handle">
                <template v-for="(rule, rule_index) in rules">
                    <div :key="`rule_${rule_index}`" :class="$style.rule_item">
                        <v-icon 
                            @click="removeRule(rule_index);"
                            color="black" 
                            small 
                            :class="$style.deleteIcon">
                            fa fa-times-circle
                        </v-icon>
                        <aside :class="[$style.ruleItemDragSection, 'handle']">
                            <svgIcon :src="dragIcon" />
                        </aside>
                        <main :class="$style.ruleItemMainSection">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-header
                                        style="background-color: #d1d1d1;"
                                        expand-icon="fas fa-angle-right">
                                            <span>Rule: {{rule_index + 1}}</span>
                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content style="padding-top: 15px;">
                                        <div :class="$style.conditionSection">
                                            <div>
                                                <v-btn 
                                                    small
                                                    depressed
                                                    color="primary" 
                                                    @click="add_condition(rule_index)"
                                                    >
                                                        Add Condition
                                                </v-btn>
                                                <v-tooltip right color="black"> 
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-icon class='ml-5'
                                                            color="black"
                                                            small 
                                                            v-bind="attrs" 
                                                            v-on="on">fas fa-info-circle</v-icon>
                                                    </template>
                                                    <span>
                                                        <b>ALL</b>&nbsp;conditions required to trigger <i>rule</i>
                                                    </span>
                                                </v-tooltip>
                                            </div>
                                            <v-spacer></v-spacer>
                                            <v-menu offset-y nudge-left='50'>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        class="mr-5"
                                                        large
                                                        icon
                                                        color="primary"
                                                        dark
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :disabled="condition_trash.length === 0"
                                                        >
                                                        <div :class="$style.conditionTrashSection">
                                                            <v-badge right>
                                                                <template v-slot:badge>
                                                                    <span>{{condition_trash.length}}</span>
                                                                </template>
                                                                <svgIcon :src="trashIcon" v-bind="attrs" v-on="on" />
                                                            </v-badge>
                                                            <span :class="$style.conditionTrashLabel">Condition Trash</span>
                                                        </div>
                                                    </v-btn>
                                                </template>
                                                
                                                <v-list v-if="condition_trash.length > 0">
                                                    <draggable class="list-group" :list="condition_trash" :group="`condition_${rule_index}`">
                                                        <v-list-item
                                                            v-for="(condition, condition_index) in condition_trash"
                                                            :key="'condition_trash_item_'+condition_index">
                                                                Deleted Condition: {{condition_index + 1}}
                                                        </v-list-item>
                                                    </draggable>
                                                </v-list>                                                        
                                                    
                                            </v-menu> 
                                        </div>
                                        <draggable 
                                            :class="[{[$style.emptyConditionWrapper]: rule.length == 0}, 'list-group']" 
                                            class="list-group" :list="rule" :group="`condition_${rule_index}`" handel=".handle">
                                            <template v-for="(condition, condition_index) in rule">
                                                <div :key="`rule_${rule_index}_condition_${condition_index}`" :class="$style.condition_item">
                                                    <v-icon 
                                                        @click="removeCondition(rule_index, condition_index);"
                                                        color="black" 
                                                        small 
                                                        :class="$style.deleteIcon">
                                                        fa fa-times-circle
                                                    </v-icon>
                                                    <aside :class="[$style.conditionItemDragSection, 'handle']">
                                                        <svgIcon :src="dragIcon" />
                                                    </aside>    
                                                    <main :class="$style.conditionItemMainSection">
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header style="background-color: white;" expand-icon="fas fa-angle-right">
                                                                    <span>{{condition.name}}</span>                                                                                                                                            
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content style="border-top: 1px solid grey;">
                                                                    <div
                                                                        :class="$style.condition"
                                                                        >
                                                                        <p :class="$style.ruleInputLabel">
                                                                            Condition Name
                                                                        </p>
                                                                        <v-text-field type='text' v-model="condition.name" outlined/>

                                                                        <p :class="$style.ruleInputLabel">
                                                                            Reference Source
                                                                            <v-tooltip right color="black"> 
                                                                                <template v-slot:activator="{on, attrs}">
                                                                                    <v-icon class='ml-2'
                                                                                        color="black"
                                                                                        small 
                                                                                        v-bind="attrs" 
                                                                                        v-on="on">fas fa-info-circle</v-icon>
                                                                                </template>
                                                                                <span>
                                                                                    <b>ALL</b>&nbsp;conditions required to trigger <i>rule</i>
                                                                                </span>
                                                                            </v-tooltip>
                                                                        </p>
                                                                        <v-select 
                                                                            outlined
                                                                            :items="[{text:'question',value:'question'},{text:'context',value:'context'}]" 
                                                                            v-model="condition.type"/>

                                                                        <template v-if="condition.type === 'question'">
                                                                            <p :class="$style.ruleInputLabel">
                                                                                Select a Question
                                                                            </p>
                                                                            <v-select outlined :items="question_ref_list" v-model="condition.ref_id" @change="set_question_type(rule_index,condition_index,condition.ref_id, condition)"/>

                                                                            <p :class="$style.ruleInputLabel">
                                                                                Group ID
                                                                            </p>
                                                                            <v-select outlined v-if="condition.ref_id" :items="group_id_list(condition.ref_id)" v-model="condition.group_id"/>
                                                                           
                                                                            <p :class="$style.ruleInputLabel">Select a Operator</p>
                                                                            <v-select outlined v-if="condition.ref_id" :items="condition_operator[questionMap[condition.ref_id].config.type]" v-model="condition.operator" @change="resetOperatorPropertyContext(condition)"/>
                                                                            <p :class="$style.ruleInputLabel">
                                                                                <v-tooltip right color="black"> 
                                                                                    <template v-slot:activator="{on, attrs}">
                                                                                        <v-icon class='ml-2'
                                                                                            color="black"
                                                                                            small 
                                                                                            v-bind="attrs" 
                                                                                            v-on="on">fas fa-info-circle</v-icon>
                                                                                    </template>
                                                                                    <span v-html="condition_operator_tooltip[condition.operator]"></span>
                                                                                </v-tooltip>
                                                                            </p>
                                                                            <v-text-field v-if="condition.operator!=='has_selected'" type='text' v-model="condition[condition.operator]" outlined :clearable="true"/>
                                                                            <template v-if="(condition.ref_id && condition.group_id && condition.input_id) || condition.operator==='has_selected'">
                                                                                <p :class="$style.ruleInputLabel">
                                                                                    Input ID
                                                                                </p>
                                                                                <template v-if="condition.group_id">
                                                                                    <v-select outlined v-model="condition.input_id" :items="input_id_list(condition.ref_id,condition.group_id)" />
                                                                                </template>                                                                                
                                                                            </template>
                                                                            
                                                                        </template>

                                                                        <template v-if="developerMode">
                                                                            <p :class="$style.ruleInputLabel">
                                                                                Advanced: Function Wrapper (question, questionMap, language) - remember to consider null values
                                                                            </p>
                                                                            <v-textarea outlined v-model="condition.advanced"/>
                                                                        </template>
                                                                    </div> 
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </main>                                              
                                                </div>
                                            </template>                                            
                                        </draggable>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </main>
                    </div>
                </template>
            </draggable>
        </div>
    </div>
</div>
</template>

<script>
import draggable from "vuedraggable";

import svgIcon from '@/components/svg/svg_icon.vue';
import dragIcon from '@/assets/images/icons/drag.svg';
import trashIcon from '@/assets/images/icons/trash.svg';
import OperatorConfig from '@/components/Survey/helpers/OperatorConfig.js';

export default {
    name: 'rule-editor',
    props: {
        display: {
            type: Boolean,
            required: true
        },
        question_id: {
            type: Number,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        survey_rules: {
            type: Object,
            reqiured: true
        },
        developerMode: {
            type: Boolean, 
            required: false,
            default: false
        }
    },
    created: function(){
        var rules = JSON.stringify(this.survey_rules);
        rules = JSON.parse(rules);
        this.rules = rules.display[this.question_id] ? rules.display[this.question_id] : [];
        for (const questionId in rules.display) {
            let questionRuleSet = rules.display[questionId]
            for (let i=0; i<questionRuleSet.length; i++){
                let rule = questionRuleSet[i];
                for (let j=0; j<rule.length; j++){
                    let condition = rule[j];
                    this.initConditionOperatorAndContent(condition);
                }
            }
        }
    },
    components: {
        draggable,
        svgIcon
    },
    data: function(){
        return {
            rules: [],
            rules_trash: [],
            condition_trash: [],
            condition_operator: OperatorConfig.map_by_question_type,
            condition_operator_tooltip: OperatorConfig.condition_operator_tooltip
        }
    },
    methods: {
        /* @Name: initConditionOperatorAndContent 
        * @Desc: Supports backward compatibility. Early SurveyEditor generated conditions did not have Operator selector defined. Rather Operator was obtained by property name contains/equals/less_than/etc
        */
        initConditionOperatorAndContent: function( condition ){
            if (condition.type==='question'){
                let refQuestionType = condition.question_type;
                let feasibleOperatorSet = this.condition_operator[refQuestionType];
                for (let i=0; i<feasibleOperatorSet.length; i++){
                    let operator = feasibleOperatorSet[i];
                    if (condition[operator]!==undefined && condition[operator]!==null){
                        condition.operator = operator;
                        break;
                    }
                    else if (refQuestionType!==null && condition.group_id!==null && condition.input_id!==null){
                        condition.operator='has_selected';
                        break;
                    }                    
                }
            }
        },
        rule_template: function(){
            return {
                name: null,
                type: 'question',
                question_type: null,
                ref_id: null,
                group_id: null,
                input_id: null,
                operator: null,
                advanced: null
            } 
        },
        add_rule: function(){
            this.rules.push([]);
        },
        add_condition: function(rule_index){
            this.rules[rule_index].push(this.rule_template())
        },
        group_id_list: function(question_id){
            var question = this.questionMap[question_id];
            var list = [{
                text: '',
                value: null
            }];
            for(let g=0; g<question.config.groups.length; g++){
                var group = question.config.groups[g];

                list.push({
                    text: group.id + (group.label.en ? " - " + group.label.en : ''),
                    value: group.id
                })
            }

            return list;
        },
        input_id_list: function(question_id, group_id){
            var question = this.questionMap[question_id];
            var list = [{
                text: '',
                value: null
            }];
            for(let g=0; g<question.config.groups.length; g++){
                var group = question.config.groups[g];
                if(group.id == group_id){
                    for(let i=0; i<group.inputs.length; i++){
                        var input = group.inputs[i];
                        list.push({
                            text: input.id + (input.label.en ? " - " + input.label.en : ''),
                            value: input.id
                        })
                    }
                }
            }

            return list;
        },
        set_question_type: function(rule_index, condition_index, question_id, condition){
            this.resetRefQuestionDependables(condition);
            if (question_id) {
                this.rules[rule_index][condition_index].question_type = this.questionMap[question_id].config.type;
            }
        },
        removeRule: function(rule_index) {
            this.rules_trash.push(this.rules[rule_index]);
            this.rules.splice(rule_index, 1);
        },
        removeCondition: function(rule_index, condition_index) {
            this.condition_trash.push(this.rules[rule_index][condition_index]);
            this.rules[rule_index].splice(condition_index, 1);
        },
        resetRefQuestionDependables: function(condition){
            if (condition.operator){
                delete condition[condition.operator];
                condition.operator = condition.group_id = condition.input_id = null;
            }
        },
        resetOperatorPropertyContext: function(condition){
            for(let i=0; i<OperatorConfig.list.length; i++){
                if (condition[OperatorConfig.list[i]]===condition.operator){
                    continue;
                }
                if (condition[OperatorConfig.list[i]]!==undefined){
                    delete condition[OperatorConfig.list[i]];
                }
                if (condition.operator!=='has_selected'){
                    condition.input_id=null;
                }
            }
            this.$forceUpdate();
        },        
    },
    computed: {
        question_ref_list: function(){
            var questionMap = this.questionMap;
            var list = [{
                text: '',
                value: null
            }];
            for(let i in questionMap){
                var question = questionMap[i];

                list.push({
                    text: i + " ["+question.config.type+"] " +question.config.body.en,
                    value: i
                })
            }

            return list;
        },
        dragIcon: function() {
            return dragIcon;
        },
        trashIcon: function() {
            return trashIcon;
        }
    },
    watch: {
        rules: {
            deep: true,
            handler: function(){
                if(this.display===false){
                    this.$emit('update',{
                        rules: this.rules,
                        question_id: this.question_id
                    })
                }
            }
        },
        display: function(){
            if(this.display===true){
                this.$emit('update',{
                    question_id: this.question_id
                })
            }
        }
    }
}
</script>

<style module>
.ruleEditorSection {
    display: flex; 
    flex-flow: wrap row; 
    justify-content: space-around; 
    align-items: center;
}

.rule_item, .condition_item {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    margin: 15px 0px 15px 0px;
    background-color: inherit;
}

.ruleItemDragSection, .conditionItemDragSection {
    cursor: grab; 
    display: flex; 
    flex-direction: column; 
    text-align: center; 
    width: 4.5%; 
    height: 65px; 
    cursor: grab;
    justify-content: center;
}

.ruleItemDragSection {
    background-color: #d1d1d1;
}

.conditionItemDragSection {
    background-color: white;
}

.ruleItemDragSection:active, .conditionItemDragSection:active {
    cursor: grabbing;
}

.ruleItemMainSection, .conditionItemMainSection {
    width: 95.5%;
}

.condition{
    padding: 15px 0;
}

.handle{
    position: relative;
    font-size: 12pt;
    z-index: 100;
}

.ruleInputLabel {
    margin-bottom: 0px !important;
    font-size: 14px; 
    color: black;
}

.rulesTrashSection, .conditionTrashSection {
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    cursor: pointer;
}

.rulesTrashLabel, .conditionTrashLabel {
    font-size: 10px; 
    color: black; 
    font-weight: 400; 
    text-transform: initial
}

.deleteIcon {
    position: absolute; 
    top: -9px; 
    right: -5px; 
    z-index:2;
    cursor: pointer;
}

.conditionSection {
    display: flex; 
    flex-flow: wrap row; 
    justify-content: space-around; 
    align-items: center;
}

.emptyRulesWrapper, .emptyConditionWrapper {
    border: 1px dashed silver;
    height: 50px;
    margin-top: 15px;
    padding-bottom: 15px;
}

.emptyRulesWrapper:after {
    content: 'Drag Rules to here...';
    margin: 0 auto;
    vertical-align: -50%;
    text-align: center;
    padding: 0 15px;
}

.emptyConditionWrapper {
    content: 'Drag Condition to here...';
    margin: 0 auto;
    vertical-align: -50%;
    text-align: center;
    padding: 0 15px;
}

</style>